jQuery(document).ready(function ($) {
    // Slider Atom
    var $carousel = $('section.slider .carousel').flickity({
        wrapAround: true,
        initialIndex: 1,
        prevNextButtons: false,
        pageDots: false,
        imagesLoaded: true
    });

    $('.carousel-controls .control').on( 'click', function(e) {
        e.preventDefault();

        $carousel.flickity($(this).attr('data-action'));
    });

    $carousel.on( 'dragStart.flickity', function( event, pointer ) {
        document.ontouchmove = function (e) {
            e.preventDefault();
        }
    });
    $carousel.on( 'dragEnd.flickity', function( event, pointer ) {
        document.ontouchmove = function (e) {
            return true;
        }
    });
});